import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

interface NewHotAndTrending {
    id: string;
    imageUrl: string;
    bodyHtml: string;
    imageAltText: string;
}

export type GetNewHotAndTrendingFn = () => Promise<
    Record<
        string,
        {
            items: NewHotAndTrending[];
        }
    >
>;

export function initGetNewHotAndTrendingFn({
    dependencies,
}: DomainInitPayload): GetNewHotAndTrendingFn {
    const { contentfulSdk } = dependencies;
    return async () => {
        try {
            /**
             * TODO:
             * Get this baseUrlCDN passed in to init function
             */
            const baseUrlCDN = 'https://www.siriusxm.com';
            /**
             * TODO
             * Make a function to get property id by key
             */
            const properties = await contentfulSdk?.getProperties({
                include: '10',
            });
            const id = properties?.find(
                (i: { key: string }) =>
                    i?.key === 'component.id-hot-and-trending',
            )?.value;

            const nhtResponse = await contentfulSdk?.getEntryById({ id });
            const nhtFields = nhtResponse?.fields as {
                default_asset_list: { sys: SysAsset }[];
            };
            const nhtSys = nhtResponse?.sys as { locale: string };
            // load each NHT entry
            const nhtEntries: { media: Media; description: any; id: string }[] =
                [];
            const nhtDefaultAssets = nhtFields?.default_asset_list;
            for (const entry of nhtDefaultAssets) {
                const entryById = await contentfulSdk?.getEntryById({
                    id: entry?.sys?.id,
                });
                nhtEntries.push({
                    ...(entryById?.fields as {
                        media: Media;
                        description: any;
                    }),
                    id: entry.sys?.id,
                });
            }
            const items = nhtEntries.map((entry) => {
                const parsedDescription = documentToHtmlString(
                    entry.description,
                    {
                        preserveWhitespace: true,
                    },
                );
                return {
                    imageUrl: `${baseUrlCDN}${entry.media?.url}`,
                    imageAltText: entry.media?.altText,
                    bodyHtml: updateAnchorTagsWithTarget(
                        parsedDescription,
                        '_blank',
                    ),
                    id: entry.id,
                };
            });

            const nht = { items, locale: nhtSys?.locale };
            const response = {
                [nht.locale]: { items: nht.items },
            };
            return response;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}

interface SysAsset {
    id: string;
    type: string;
    linkType: string;
}

interface Media {
    url: string;
    altText: string;
    fileType: string;
    format: string;
}
/**
 * TODO[techdebt]:
 * Elevate this out to a new lib for re-use.
 * Replace usage in other libs with the same function
 */
export const updateAnchorTagsWithTarget = (
    html: string,
    targetValue: string,
): string => {
    const regex = /<a\s+(?!.*?\btarget=)[^>]*>/g;
    return html.replace(regex, (match) => {
        return match.slice(0, -1) + ` target="${targetValue}">`;
    });
};
